import { render, staticRenderFns } from "./ObraActionBar.vue?vue&type=template&id=24355483"
import script from "./ObraActionBar.vue?vue&type=script&lang=js"
export * from "./ObraActionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports